import Joi from "joi";

export const moduleNamespace = 'registration';

export const SET_LAYOUT = 'SET_LAYOUT';
export const SET_CONFIGURATION = 'SET_CONFIGURATION';
export const SET_NAME = 'SET_NAME';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_OPERATION_COUNTRY = 'SET_OPERATION_COUNTRY';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_STAGE = 'SET_STAGE';
export const SET_PACKAGE_PRICE_FROM_RESPONSE = 'SET_PACKAGE_PRICE_FROM_RESPONSE';
export const SET_STRIPE_PAYMENT_METHOD_ID = 'SET_STRIPE_PAYMENT_METHOD_ID';
export const SET_REGISTRATION_TOKEN = 'SET_REGISTRATION_TOKEN';
export const SET_STRIPE_REDIRECT = 'SET_STRIPE_REDIRECT';

export const STAGES = [
  'CUSTOMER_INFORMATION',
  'PAYMENT_INFORMATION',
  'REGISTRATION_COMPLETE',
];

export const NAME_SCHEMA = Joi.string().label('Name').required();
export const EMAIL_SCHEMA = Joi.string().label('Email address').email({
  tlds: false,
});
export const PASSWORD_SCHEMA = Joi.string().label('Password').required();
